import {createRouter, createWebHistory} from 'vue-router'

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/generation-history',
    name: 'GenerationHistory',
    component: () => import('../pages/GenerationHistory.vue')
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('../pages/HomeView.vue')
  },
  {
    path: '/login',
    name: "Login",
    component: () => import('../pages/LoginView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
